import { createRouter, createWebHistory } from "vue-router";
import Layout from "../components/layout/Layout.vue";
import BlogLayout from "../components/layout/BlogLayout.vue";
import EmptyLayout from "../components/layout/EmptyLayout.vue";

import store from "../store";
import VueCookies from "vue-cookies";
import VueJwtDecode from "vue-jwt-decode";
import { supabase } from "@/API/supabase";

const routes = [
  {
    path: "/",
    redirect: "/home",
    meta: {
      title: "home",
    },
  },
  {
    path: "/home",
    name: "home",
    component: () => import("../views/main/main"),
    meta: {
      title: "home",
      layout: Layout, // layout 속성을 meta로 이동
    },
  },

  // SYMPOSIUM SKETCH
  {
    path: "/symposium",
    name: "symposium",
    component: () => import("../views/main/symposium"),
    meta: {
      title: "SYMPOSIUM SKETCH",
      layout: Layout,
    },
  },

  // Apply for Lectures > new
  {
    path: "/applyforlecturesNew/:lecture_id/:lecture_type",
    name: "applyforlecturesNew",
    component: () => import("../views/main/applyforlecturesNew"),
    meta: {
      authRequired: true,
      title: "Apply for Lectures",
      layout: Layout,
    },
  },

  {
    path: "/applyforlecturesList",
    name: "applyforlecturesList",
    component: () => import("../views/main/applyforlecturesList"),
    meta: {
      authRequired: true,
      title: "Apply for Lectures",
      layout: Layout,
    },
  },

  // 로그인
  {
    path: "/login",
    name: "login",
    component: () => import("../views/account/login"),
    meta: {
      title: "login",
      layout: Layout,
    },
  },

  // 회원가입
  {
    path: "/signup",
    name: "signup",
    component: () => import("../views/account/signup"),
    meta: {
      title: "Create your KOREADERMA account",
      layout: Layout,
    },
  },

  // 로그인 후 International registrants_onsite
  {
    path: "/internationalregistrants_onsite",
    name: "internationalregistrants_onsite",
    component: () => import("../views/account/internationalregistrants_onsite"),
    meta: {
      authRequired: true,
      title: "International registrants_onsite",
      layout: Layout,
    },
  },

  // 로그인 후 Checkout
  {
    path: "/checkout/:product_id/:option_index/:gala_yn",
    name: "checkout",
    component: () => import("../views/account/checkout"),
    meta: {
      authRequired: true,
      title: "Checkout",
      layout: Layout,
    },
  },

  // 결제 결과
  {
    path: "/paymentResult",
    name: "paymentResult",
    component: () => import("../views/account/paymentResult"),
    meta: {
      authRequired: true,
      title: "PaymentResult",
      layout: Layout,
    },
  },

  // 비밀번호 찾기
  {
    path: "/forgotpassword",
    name: "forgotpassword",
    component: () => import("../views/account/forgotpassword"),
    meta: {
      title: "Forgot Password",
      layout: Layout,
    },
  },

  // 비밀번호 재설정
  {
    path: "/resetpassword/:token",
    name: "resetpassword",
    component: () => import("../views/account/resetpassword"),
    meta: {
      title: "Reset Password",
      layout: Layout,
    },
  },

  // privacy
  {
    path: "/privacy",
    name: "privacy",
    component: () => import("../views/privacy"),
    meta: {
      title: "Privacy Policies",
      layout: Layout,
    },
  },

  // registration > guide
  {
    path: "/registration/guide",
    name: "registrationGuide",
    component: () => import("../views/registration/guide"),
    meta: {
      title: "Registration",
      layout: Layout,
    },
  },

  // registration > register
  {
    path: "/registration/register",
    name: "registrationRegister",
    component: () => import("../views/registration/register"),
    meta: {
      title: "Register",
      layout: Layout,
    },
  },

  // Program > Detailed Program
  {
    path: "/program/detailed",
    name: "programDetailed",
    component: () => import("../views/program/detailed"),
    meta: {
      title: "Detailed Program",
      layout: Layout,
    },
  },

  // Program > Program Details
  {
    path: "/program/detailedView/:program_id",
    name: "programDetailedView",
    component: () => import("../views/program/detailedView"),
    meta: {
      title: "Program Details",
      layout: Layout,
    },
  },

  // Speaker > Our Speakers
  {
    path: "/speaker/ourspeakers",
    name: "speakerOurSpeakers",
    component: () => import("../views/speaker/ourspeakers"),
    meta: {
      title: "Our Speakers",
      layout: Layout,
    },
  },

  // Speaker > Become a Speaker
  {
    path: "/speaker/becomespeaker",
    name: "speakerBecomeSpeaker",
    component: () => import("../views/speaker/becomespeaker"),
    meta: {
      title: "Become a Speaker",
      layout: Layout,
    },
  },

  //  Speaker > Speaker Detail
  {
    path: "/speaker/speakerdetail/:useruid",
    name: "speakerDetail",
    component: () => import("../views/speaker/speakerdetail"),
    meta: {
      title: "Speaker Detail",
      layout: Layout,
    },
  },

  // Venue > Venue Information
  {
    path: "/venue/venueinfo",
    name: "venueInfo",
    component: () => import("../views/venue/venueinfo"),
    meta: {
      title: "Venue Information",
      layout: Layout,
    },
  },

  // Venue > Access to the Venue
  {
    path: "/venue/access",
    name: "venueAccess",
    component: () => import("../views/venue/access"),
    meta: {
      title: "Access to the Venue",
      layout: Layout,
    },
  },

  // Abstract > Guideline
  {
    path: "/abstract/guideline",
    name: "abstractGuideline",
    component: () => import("../views/abstract/guideline"),
    meta: {
      title: "Guideline",
      layout: Layout,
    },
  },

  // Abstract > E-Poster
  {
    path: "/abstract/e-poster",
    name: "abstractEPoster",
    component: () => import("../views/abstract/e-poster"),
    meta: {
      title: "E-Poster",
      layout: Layout,
    },
  },

  // Sponsor > Our Sponsors
  {
    path: "/sponsor/oursponsors",
    name: "sponsorOurSponsors",
    component: () => import("../views/sponsor/oursponsors"),
    meta: {
      title: "Our Sponsors",
      layout: Layout,
    },
  },

  // Sponsor > Sponsorship
  {
    path: "/sponsor/sponsorship",
    name: "sponsorSponsorship",
    component: () => import("../views/sponsor/sponsorship"),
    meta: {
      title: "Sponsorship",
      layout: Layout,
    },
  },

  // Sponsor > Sponsorship > Sponsorship Registration
  {
    path: "/sponsor/sponsorshipregi",
    name: "sponsorSponsorshipRegi",
    component: () => import("../views/sponsor/sponsorshipregi"),
    meta: {
      title: "Sponsorship Registration",
      layout: Layout,
    },
  },

  // Event > Gala
  {
    path: "/event/gala",
    name: "eventGala",
    component: () => import("../views/event/gala"),
    meta: {
      title: "Gala",
      layout: Layout,
    },
  },

  // Event > Engagement Event
  {
    path: "/event/engagement",
    name: "eventEngagement",
    component: () => import("../views/event/engagement"),
    meta: {
      title: "Engagement Event",
      layout: Layout,
    },
  },

  // Travel Info > About SEOUL
  {
    path: "/travelinfo/aboutseoul",
    name: "aboutSeoul",
    component: () => import("../views/travelinfo/aboutseoul"),
    meta: {
      title: "About SEOUL",
      layout: Layout,
    },
  },

  // Travel Info > Themed Trip
  {
    path: "/travelinfo/themedtrip",
    name: "themedTrip",
    component: () => import("../views/travelinfo/themedtrip"),
    meta: {
      title: "Themed Trip",
      layout: Layout,
    },
  },

  // Travel Info > Booking Hotel
  {
    path: "/travelinfo/bookinghotel",
    name: "bookingHotel",
    component: () => import("../views/travelinfo/bookinghotel"),
    meta: {
      title: "Booking Hotel",
      layout: Layout,
    },
  },

  // Travel Info > Useful Inform
  {
    path: "/travelinfo/usefulinform",
    name: "usefulInform",
    component: () => import("../views/travelinfo/usefulinform"),
    meta: {
      title: "Useful Inform",
      layout: Layout,
    },
  },

  // Travel Info > Useful Inform > Visa Letter
  {
    path: "/travelinfo/visaLetter",
    name: "visaLetter",
    component: () => import("../views/travelinfo/visaLetter"),
    meta: {
      title: "Visa Letter",
      layout: Layout,
    },
  },

  // My Account
  {
    path: "/account/myaccount",
    name: "myaccount",
    component: () => import("../views/account/myaccount"),
    meta: {
      authRequired: true,
      title: "Dashboard",
      layout: Layout,
    },
  },

  // Blog main
  {
    path: "/blog/search",
    name: "blogSearch",
    component: () => import("../views/blog/search.vue"),
    meta: {
      title: "Blog Search",
      layout: EmptyLayout,
    },
  },

  // Blog
  {
    path: "/blog/:useruid",
    name: "blog",
    component: () => import("../views/blog/blog.vue"),
    meta: {
      title: "Blog",
      layout: BlogLayout,
    },
  },

  // Streaming
  {
    path: "/streaming",
    name: "streaming",
    component: () => import("../views/streaming/video.vue"),
    meta: {
      authRequired: true,
      title: "Streaming",
      // layout: Layout,
    },
  },
];

const router = createRouter({
  mode: "history",
  history: createWebHistory(),
  linkActiveClass: "active",
  //linkExactActiveClass: 'active',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { left: 0, top: 0 };
    }
  },
});

router.beforeEach((to, from, next) => {
  /*
   * to: 이동할 url 정보가 담긴 라우터 객체
   * from: 현재 url 정보가 담긴 라우터 객체
   * next: to에서 지정한 url로 이동하기 위해 꼭 호출해야 하는 함수
   * next() 가 호출되기 전까지 화면 전환되지 않음
   */

  // next();

  // store.commit('logoutUser');
  // const { error } = supabase.auth.signOut();

  var token = VueCookies.get("koreaderma_accessToken");
  var profileComplete = VueCookies.get("koreaderma_profileComplete");
  // console.log(token);
  var isVerified = false;

  if (token !== null) {
    if (token.includes(".")) {
      var decoded = decodeJwt(token);
      var payload = decoded.payload;
      var expTime = payload.exp;
      var expireDate = new Date(expTime * 1000);
      var today = new Date();
      if (expireDate > today) {
        isVerified = true;
      }

      // ****** 기존 디코딩 방식 - 페이스북 token 디코딩 오류로 인한 변경 (atob 관련 오류) ******
      // let decoded = VueJwtDecode.decode(token)
      // console.log(decoded);
      // var expTime = decoded.exp;
      // var expireDate = new Date(expTime * 1000);
      // var today = new Date();

      // if(expireDate > today){
      //     isVerified = true;
      // }
    }
  }

  if (store.state.user.loggedIn) {
    if (
      profileComplete == true ||
      profileComplete == "true" ||
      to.path === "/account/myaccount" ||
      to.path === "/home"
    ) {
      next();
    } else {
      alert("Please fill out the profile information.");
      next("/account/myaccount");
    }
  } else {
    if (token !== null) {
      //console.log("accessToken이 있을 경우 진행");
      //accessToken이 있을 경우 진행
      var userInfo = {
        accessToken: VueCookies.get("koreaderma_accessToken"),
        refreshToken: VueCookies.get("koreaderma_refreshToken"),
        email: VueCookies.get("koreaderma_email"),
        useruid: VueCookies.get("koreaderma_useruid"),
        profileComplete: VueCookies.get("koreaderma_profileComplete"),
      };

      //console.log(userInfo);

      if (isVerified) {
        store.commit("setLoggedIn", true);
        store.commit("setUser", userInfo);

        if (
          profileComplete == true ||
          profileComplete == "true" ||
          to.path === "/account/myaccount" ||
          to.path === "/home"
        ) {
          next();
        } else {
          alert("Please fill out the profile information.");
          next("/account/myaccount");
        }
      } else {
        const authRequired = to.matched.some(
          (route) => route.meta.authRequired
        );

        store.commit("logoutUser");
        const { error } = supabase.auth.signOut();

        if (authRequired) {
          next("/login");
        } else {
          next();
        }
      }
    } else {
      const authRequired = to.matched.some((route) => route.meta.authRequired);

      if (!authRequired) {
        next();
      } else {
        next("/login");
      }
    }
  }
});

function base64UrlDecode(str) {
  // Base64Url에서 표준 Base64로 변환
  let base64 = str.replace(/-/g, "+").replace(/_/g, "/");
  // 패딩 추가 (4의 배수가 되도록)
  while (base64.length % 4 !== 0) {
    base64 += "=";
  }
  return atob(base64);
}

function decodeJwt(token) {
  const parts = token.split(".");
  if (parts.length !== 3) {
    throw new Error("잘못된 JWT 형식입니다.");
  }

  const header = JSON.parse(base64UrlDecode(parts[0]));
  const payload = JSON.parse(base64UrlDecode(parts[1]));

  return { header, payload };
}

export default router;
